import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";

export default function AccordianCards({
  item,
  index,
  cardKet,
  setCardData,
  setComponentOpen,
  setComponentData,
  cardType,
}) {
  const [expanded, setExpanded] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const cardConfig = cardKet[cardType];
  const summaryKeys = Array.isArray(cardConfig[0]) ? cardConfig[0] : "";
  const detailKeys = Array.isArray(cardConfig[1]) ? cardConfig[1] : "";
  return (
    <>
      {/* <Accordion
        expanded={expanded}
        sx={{
          width: "100%",
          ":hover": {
            bgcolor: "#2892ba17",
          },
          cursor: "pointer",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={(event) => {
            event.stopPropagation();
            setExpanded(!expanded);
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography
                color="primary"
                sx={{ fontSize: "14px", fontWeight: 600 }}
              >
                {summaryKeys.label} :
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                color="secondary"
                sx={{ fontSize: "14px", fontWeight: 600 }}
              >
                {item?.[summaryKeys.key]}
              </Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid
              container
              sx={{
                padding: "12px",
              }}
            >
              {detailKeys.map((ele, idx) => (
                <Grid
                  item
                  xs={
                    cardType == "incentive" ? 2 : cardType == "Deductions" ? 3 : 5
                  }
                  key={idx}
                >
                  <Typography
                    color="primary"
                    sx={{
                      fontSize: "14px",
                      fontWeight: 600,
                      marginBottom: "8px",
                      textAlign:
                        idx === 0
                          ? "left"
                          : idx === detailKeys.length - 1
                            ? "right"
                            : "center",
                    }}
                  >
                    {ele.label}
                  </Typography>
                </Grid>
              ))}
              <Grid item xs={2}>
                <Typography
                  color="primary"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    marginBottom: "8px",
                    textAlign: "right",
                  }}
                ></Typography>
              </Grid>
            </Grid>
            {item?.componentDetails?.map((component, index) => (
              <Grid
                container
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "8px",
                  padding: "12px",
                  borderBottom: "1px solid rgb(198, 197, 197)",
                }}
              >
                {detailKeys.map((detail, index) => (
                  <Grid
                    item
                    xs={
                      cardType == "incentive"
                        ? 2
                        : cardType == "Deductions"
                          ? 3
                          : 5
                    }
                    key={detail.key}
                  >
                    <Typography
                      color={index === 0 ? "secondary" : "inherit"}
                      sx={{
                         fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        "-webkit-line-clamp": "1",
                        "-webkit-box-orient": "vertical",
                        textAlign:
                          index === 0
                            ? "left"
                            : index === detailKeys.length - 1
                              ? "right"
                              : "center",
                      }}
                    >
                      {component?.[detail.key]}
                    </Typography>
                  </Grid>
                ))}
                <Grid item xs={2} sx={{ textAlign: "right" }}>
                  <EditIcon
                    sx={{
                      cursor: "pointer",
                      color: "primary.main",
                    }}
                    onClick={(event) => {
                      setComponentOpen(true);
                      setComponentData(component);
                      setCardData(item);
                      console.log("component", component);
                    }}
                  />
                </Grid>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion> */}

      <Accordion
        expanded={expanded}
        sx={{
          borderTopRightRadius: "30px",
          borderTopLeftRadius: "30px",
          borderBottomRightRadius: expanded ? "" : "20px",
          borderBottomLeftRadius: expanded ? "" : "20px",
          backgroundColor: expanded ? "#01008B" : "#E3E3FF",
          boxShadow: "none",
        }}
      >
        <AccordionSummary
          expandIcon={
            <Box
              sx={{
                color: expanded ? "white" : "black",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              <ExpandMoreIcon />
            </Box>
          }
          onClick={(event) => {
            event.stopPropagation();
            setExpanded(!expanded);
            setSelectedIndex(index);
          }}
          aria-controls="panel1a-content"
          id="panel1a-header"
          // xs={{background:"#01008B"}}

          sx={{
            background: "#01008B",
            borderTopRightRadius: "20px",
            borderTopLeftRadius: "20px",
            borderBottomRightRadius: expanded ? "" : "20px",
            borderBottomLeftRadius: expanded ? "" : "20px",
            backgroundColor: expanded ? "#01008B" : "#E3E3FF",
          }}
        >
          <Grid container>
            <Grid item xs={cardType == "incentive" ? 5.5 : 2}>
              <Typography
                color="white"
                sx={{
                  fontSize: { xs: "10px", sm: "13px", md: "15px" },
                  // overflow: "Hidden",
                  fontWeight: 500,
                  textAlign: "center",
                  whiteSpace: "normal",

                  color: expanded ? "white" : "black",
                  // textOverflow: "ellipsis",
                }}
              >
                {item?.[summaryKeys[0].key]}
              </Typography>
            </Grid>

            <Grid
              item
              xs={6}
              color={"white"}
              sx={{
                color: "black",
                fontWeight: 500,
                display: "flex",
                // justifyContent: "start",
                // alignItems: "center",
                textAlign: "left",
                // pl:1,
                whiteSpace: "normal",
                paddingLeft:
                  cardType == "incentive"
                    ? "20px"
                    : { xs: "25px", md: "52px", lg: "85px" },
                color: expanded ? "white" : "black",
                fontSize: { xs: "10px", sm: "13px", md: "15px" },
              }}
            >
              {item?.[summaryKeys[1].key]}
            </Grid>

            {summaryKeys[2].key === "totalAmount" &&
              cardType != "incentive" && (
                <Grid
                  item
                  xs={4}
                  color={"white"}
                  sx={{
                    color: "black",
                    fontWeight: { sm: 500, xs: 600 },
                    // display: "flex",
                    // justifyContent: "center",
                    // alignItems: "center",
                    textAlign: "right",
                    pr: { sm: 4, xs: 0, lg: 15 },
                    color: expanded ? "white" : "black",
                    fontSize: { xs: "10px", sm: "13px", md: "15px" },
                  }}
                >
                  ₹ {item?.[summaryKeys[2].key]?.toFixed(2)}
                </Grid>
              )}
          </Grid>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            m: "0px",
            background: "#E3E3FF",
            py: "20px",
            px: { xs: "1px", sm: "80px" },
          }}
        >
          <Box
            sx={
              cardType === "incentive"
                ? { overflowX: "auto", width: "100%" }
                : {}
            }
          >
            <Box sx={cardType === "incentive" ? { minWidth: "400px" } : {}}>
              <Grid container sx={{ py: 1, px: 1 }}>
                <Grid item xs={11}>
                  <Grid container>
                    {detailKeys?.map((detailKey, index) => {
                      let gridCol = 12 / detailKeys?.length;
                      return (
                        <Grid key={index} item xs={gridCol ?? "auto"}>
                          <Typography
                            color="primary"
                            sx={{
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              textAlign:
                                index === detailKeys?.length - 1
                                  ? "end"
                                  : "start",
                              fontFamily: "'Montserrat', sans-serif",
                              fontWeight: 500,
                            }}
                          >
                            {detailKey.label}
                          </Typography>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>

              {item?.componentDetails?.map((item2, index) => (
                <Grid
                  container
                  key={index}
                  sx={{
                    borderBottom: "1px solid black",
                    marginBottom: "20px",
                    py: 1,
                    px: 1,
                  }}
                >
                  <Grid item xs={11}>
                    <Grid container>
                      {detailKeys?.map((detailKey, index) => {
                        let gridCol = 12 / detailKeys?.length;
                        return (
                          <Grid key={index} item xs={gridCol ?? "auto"}>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight:
                                  detailKey.key === "amount" ? 500 : 400,
                                fontFamily: "'Montserrat', sans-serif",
                                textAlign:
                                  index === detailKeys?.length - 1
                                    ? "end"
                                    : "start",
                              }}
                            >
                              {detailKey.key === "amount"
                                ? `₹ ${item2?.[detailKey.key]}`
                                : item2?.[detailKey.key]}
                            </Typography>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                  <Grid item xs={1} sx={{ textAlign: "end" }}>
                    <EditIcon
                      sx={{
                        cursor: "pointer",
                        color: "primary.main",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                      onClick={() => {
                        setComponentOpen(true);
                        setComponentData(item2);
                        setCardData(item);
                      }}
                    />
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
